import { Component } from '@angular/core';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent {
  listPermissions: { id: number, name: string }[] = [
    { id: 1, name: 'Admin' },
    { id: 2, name: 'SuperAdmin' },
    { id: 3, name: 'ESN' },
    { id: 4, name: 'Client final' },
  ]
}
